import React from 'react'
import SalesReports from '../components/reports/SalesReports'
import {HiOutlineDocumentReport} from 'react-icons/hi'
import { useTranslation } from 'react-i18next'
import RequisitionsReports from '../components/reports/RequisitionReportComponent'

const OsRequisitionReportCom = () => {
    const [t,i18n ] = useTranslation('global')
        const isRTL = i18n.dir() === 'rtl';
    return (
        <div className='flex flex-col p-5 '>
            <RequisitionsReports/>
        </div>
    )
}

export default OsRequisitionReportCom